export enum SumoModules {
  planLink = "planLink",
  activePlan = "activePlan",
}
